import React, { HTMLInputTypeAttribute, ReactNode } from "react";

import { TextField } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

export const TextWithValidation = ({
  label,
  value,
  onChange,
  type = "text",
  error = false,
  helperText,
  placeholder,
  disabled = false,
}: TextWithValidationProps) => {
  return (
    <TextField
      value={value}
      onChange={(e) => onChange(e.target.value)}
      label={label}
      type={type}
      error={error}
      helperText={helperText}
      placeholder={placeholder}
      variant="outlined"
      InputProps={{
        endAdornment: <EditOutlined />,
      }}
      disabled={disabled}
    />
  );
};

export type TextWithValidationProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: HTMLInputTypeAttribute;
  error?: boolean;
  helperText?: ReactNode;
  placeholder?: string;
  disabled?: boolean;
};
